import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import * as React from "react";
import styled from "../../styled-components";
import { replaceHashInColor } from "../../appTheme";
import { TileHeader, TileText } from "./styled.elements";
import { UniversalLink } from "../../components/UniversalLink/UniversalLink";
var WideTileWrapper = styled(UniversalLink)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n\n  flex-direction: ", ";\n  border-radius: 10px;\n  box-shadow: 0px 10px 30px 0px rgba(35, 35, 35, 0.1);\n  background-color: ", ";\n  background-image: ", ";\n  background-repeat: no-repeat;\n  padding: 24px;\n  padding-right: ", ";\n  margin-bottom: 32px;\n  box-sizing: border-box;\n  position: relative;\n  text-decoration: none;\n  width: 100%;\n  transition: box-shadow 0.25s ease;\n\n  :hover {\n    box-shadow: 0px 10px 30px 0px rgba(35, 35, 35, 0.2);\n  }\n\n  :before {\n    content: ", ";\n    background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 163.8 285.5\"><path class=\"st0\" d=\"m157.8 127.7l-121.8-121.7c-8-8-21-8-29 0s-8 21 0 29l107.2 107.2-108.2 108.3c-8 8-8 21 0 29 4 4 9.3 6 14.5 6s10.5-2 14.5-6l122.8-122.8c3.8-3.8 6-9.1 6-14.5s-2.2-10.6-6-14.5z\" fill=\"", "\"/></svg>');\n    display: inline-block;\n    width: 9px;\n    min-height: 18px;\n    background-size: 9px 18px;\n    background-repeat: no-repeat;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 30px;\n  }\n\n  &.external-url::after {\n    content: none;\n  }\n\n  @media only screen and (min-width: ", ") {\n    width: calc(50% - 2em);\n    padding: 32px;\n    padding-right: ", ";\n    flex-direction: row;\n    max-width: ", ";\n  }\n"])), function (_ref) {
  var a = _ref.withIcon;
  return a ? "column" : "row";
}, function (_ref2) {
  var a = _ref2.bgColor;
  return a || "#fff";
}, function (_ref3) {
  var a = _ref3.bgImage;
  return a ? "url(" + a + ")" : "none";
}, function (_ref4) {
  var a = _ref4.disableArrow;
  return a ? "24px" : "56px";
}, function (_ref5) {
  var a = _ref5.disableArrow;
  return a ? "none" : "\"\"";
}, function (a) {
  return replaceHashInColor(a.color || a.theme.colors.primary.main);
}, function (_ref6) {
  var a = _ref6.theme;
  return a.breakpoints.medium;
}, function (_ref7) {
  var a = _ref7.disableArrow;
  return a ? "32px" : "64px";
}, function (_ref8) {
  var a = _ref8.maxWidth;
  return a;
}),
    WideTileHeader = styled(TileHeader)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 24px;\n  text-align: ", ";\n"])), function (_ref9) {
  var a = _ref9.align;
  return a || "left";
}),
    WideTileText = styled(TileText)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  text-align: ", ";\n"])), function (_ref10) {
  var a = _ref10.align;
  return a || "left";
}),
    WideTileIcon = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n  flex-shrink: 0;\n  width: 70px;\n  img {\n    display: block;\n    height: auto;\n    max-width: 100%;\n  }\n  @media only screen and (min-width: ", ") {\n    margin-right: 24px;\n    margin-bottom: 0;\n  }\n"])), function (_ref11) {
  var a = _ref11.theme;
  return a.breakpoints.medium;
});
export var WideTile = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(WideTile, _React$Component);

  function WideTile() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = WideTile.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a = _this$props.to,
        b = _this$props.header,
        c = _this$props.children,
        d = _this$props.target,
        e = _this$props.disableArrow,
        f = _this$props.textAlign,
        g = _this$props.headerAlign,
        h = _this$props.icon,
        i = _this$props.bgColor,
        j = _this$props.bgImage,
        k = _this$props.color,
        l = _this$props.className,
        m = _this$props.style,
        n = _this$props.maxWidth;
    return /*#__PURE__*/React.createElement(WideTileWrapper, {
      to: a,
      target: d,
      disableArrow: e,
      withIcon: !!h,
      bgColor: i,
      bgImage: j,
      color: k,
      className: l,
      style: m,
      maxWidth: n
    }, h && /*#__PURE__*/React.createElement(WideTileIcon, null, /*#__PURE__*/React.createElement("img", {
      src: h,
      alt: ""
    })), /*#__PURE__*/React.createElement("div", null, b && /*#__PURE__*/React.createElement(WideTileHeader, {
      align: f,
      color: k,
      "data-cy": "Wide-" + b
    }, b), c && /*#__PURE__*/React.createElement(WideTileText, {
      align: g,
      color: k
    }, c)));
  };

  return WideTile;
}(React.Component);